export enum EnEditCtrl {
    InputText,
    InputNumber,
    Select,
    Text
}
